import React from "react";
import ReactDOM from "react-dom/client";
// react router
import { BrowserRouter } from "react-router-dom";
// components
import App from "./App";
import { CacheThemeProvider } from "./components";
// styles
import "./index.css";
// react redux
import store from "./redux/store";
import { Provider } from "react-redux";
const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <CacheThemeProvider>
                    <App />
                </CacheThemeProvider>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>
);
